import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/browse',
    name: 'browse',
    component: () => import('../views/browse.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/predict',
    name: 'predict',
    component: () => import('../views/predict.vue')
  },
  {
    path: '/predictresult',
    name: 'predictresult',
    component: () => import('../views/predictresult.vue')
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: () => import('../views/downloads.vue')
  },
  {
    path: '/listview',
    name: 'listview',
    component: () => import('../views/Listview.vue')
  },
  {
    path: '/listview_comp',
    name: 'listviewcom',
    component: () => import('../views/ListviewCom.vue')
  },
  {
    path: '/species',
    name: 'species',
    component: () => import('../views/species.vue')
  },
  {
    path: '/compounds',
    name: 'compounds',
    component: () => import('../views/compounds.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
